import { PayloadAction } from "@reduxjs/toolkit";
import { put, takeEvery, call } from "redux-saga/effects";
import { LoadingOrderActions } from "redux/actions";
import LoadingOrderApiService from "services/LoadingOrderApiService";
import {
  IApiResponse,
  IErrorResponse,
  IGetLoadingOrderPalletsRequest,
  IGetRelatedDocumentRequest,
  ILoadingOrderPallet,
  IPaginateApiResponse,
  IPaginationRequest,
  IRelatedDocument,
  IImportLoadingOrderDocument,
  IUpdateLoadingOrderDocumentRequest,
} from "model";
import { ILoadingOrder } from "model/LoadingOrder/ILoadingOrder";
import {
  IGetLoadingOrderProductRequest,
  ILoadingOrderProduct,
} from "model/LoadingOrder/ILoadingOrderProduct";
import {
  IDeliveryProgress,
  IGetDeliveryProgressRequest,
} from "model/LoadingOrder/IDeliveryProgress";
import { AlertHelper } from "helpers";
import { EAlertType } from "helpers/alertHelper";

function* getAllLoadingOrder(action: PayloadAction<IPaginationRequest>) {
  try {
    const result: IPaginateApiResponse<ILoadingOrder[]> = yield call(
      LoadingOrderApiService.getAllLoadingOrder,
      action.payload
    );
    if (result.succeeded) {
      yield put(LoadingOrderActions.getAllLoadingOrder.success(result));
    } else {
      const error = result as IErrorResponse;
      yield put(LoadingOrderActions.getAllLoadingOrder.failed(error));
    }
  } catch (error) {
    yield put(LoadingOrderActions.getAllLoadingOrder.failed(error));
  }
}
function* getAllLoadingOrderProducts(
  action: PayloadAction<IGetLoadingOrderProductRequest>
) {
  try {
    const result: IPaginateApiResponse<ILoadingOrderProduct[]> = yield call(
      LoadingOrderApiService.getAllLoadingOrderProducts,
      action.payload
    );
    if (result.succeeded) {
      yield put(LoadingOrderActions.getAllLoadingOrderProducts.success(result));
    } else {
      const error = result as IErrorResponse;
      yield put(LoadingOrderActions.getAllLoadingOrderProducts.failed(error));
    }
  } catch (error) {
    yield put(LoadingOrderActions.getAllLoadingOrderProducts.failed(error));
  }
}
function* getDeliveryProgress(
  action: PayloadAction<IGetDeliveryProgressRequest>
) {
  try {
    const result: IPaginateApiResponse<IDeliveryProgress[]> = yield call(
      LoadingOrderApiService.getDeliveryProgress,
      action.payload
    );
    if (result.succeeded) {
      yield put(LoadingOrderActions.getDeliveryProgress.success(result));
    } else {
      const error = result as IErrorResponse;
      yield put(LoadingOrderActions.getDeliveryProgress.failed(error));
    }
  } catch (error) {
    yield put(LoadingOrderActions.getDeliveryProgress.failed(error));
  }
}

function* getAllLoadingOrderPallets(
  action: PayloadAction<IGetLoadingOrderPalletsRequest>
) {
  try {
    const result: IPaginateApiResponse<ILoadingOrderPallet[]> = yield call(
      LoadingOrderApiService.getAllLoadingOrderPallets,
      action.payload
    );
    if (result.succeeded) {
      yield put(LoadingOrderActions.getAllLoadingOrderPallets.success(result));
    } else {
      const error = result as IErrorResponse;
      yield put(LoadingOrderActions.getAllLoadingOrderPallets.failed(error));
    }
  } catch (error) {
    yield put(LoadingOrderActions.getAllLoadingOrderPallets.failed(error));
  }
}

function* getRelatedDocuments(
  action: PayloadAction<IGetRelatedDocumentRequest>
) {
  try {
    const result: IPaginateApiResponse<IRelatedDocument[]> = yield call(
      LoadingOrderApiService.getRelatedDocuments,
      action.payload
    );
    if (result.succeeded) {
      yield put(LoadingOrderActions.getRelatedDocuments.success(result));
    } else {
      const error = result as IErrorResponse;
      yield put(LoadingOrderActions.getRelatedDocuments.failed(error));
    }
  } catch (error) {
    yield put(LoadingOrderActions.getRelatedDocuments.failed(error));
  }
}

function* updateLODocument(
  action: PayloadAction<IUpdateLoadingOrderDocumentRequest>
) {
  try {
    const result: IApiResponse<ILoadingOrder> = yield call(
      LoadingOrderApiService.updateLoadingOrderDocument,
      action.payload
    );
    if (result.succeeded) {
      yield put(LoadingOrderActions.updateLODocument.success(result.data!));
      AlertHelper.showAlert("Update Document Successfully", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(LoadingOrderActions.updateLODocument.failed(error));
    }
  } catch (error) {
    yield put(LoadingOrderActions.updateLODocument.failed(error));
  }
}

function* importLoadingOrderDocument(
  action: PayloadAction<IImportLoadingOrderDocument>
) {
  try {
    const result: IApiResponse<any> = yield call(
      LoadingOrderApiService.importLoadingOrderDocument,
      action.payload
    );
    if (result.succeeded) {
      yield put(LoadingOrderActions.importLoadingOrderDocument.success(result));
      AlertHelper.showAlert("Import Document Successfully", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(LoadingOrderActions.importLoadingOrderDocument.failed(error));
    }
  } catch (error) {
    yield put(LoadingOrderActions.importLoadingOrderDocument.failed(error));
  }
}

export function* Watcher() {
  yield takeEvery(
    LoadingOrderActions.getAllLoadingOrder.request,
    getAllLoadingOrder
  );
  yield takeEvery(
    LoadingOrderActions.getAllLoadingOrderProducts.request,
    getAllLoadingOrderProducts
  );
  yield takeEvery(
    LoadingOrderActions.getDeliveryProgress.request,
    getDeliveryProgress
  );
  yield takeEvery(
    LoadingOrderActions.getAllLoadingOrderPallets.request,
    getAllLoadingOrderPallets
  );
  yield takeEvery(
    LoadingOrderActions.getRelatedDocuments.request,
    getRelatedDocuments
  );
  yield takeEvery(
    LoadingOrderActions.updateLODocument.request,
    updateLODocument
  );
  yield takeEvery(
    LoadingOrderActions.importLoadingOrderDocument.request,
    importLoadingOrderDocument
  );
}
